import {Component} from "@angular/core";
import {LandingPageComponent} from "../../../public-landing-page/components/landing-page/landing-page.component";
import {AbstractPublicLandingPageService, LandingPageTrackingService} from "fello-common";
import {PublicPURLPageService} from "../../services/public-purlpage.service";

@Component({
  selector: "app-purlpage",
  templateUrl: "../../../public-landing-page/components/landing-page/landing-page.component.html",
  styleUrls: ["../../../public-landing-page/components/landing-page/landing-page.component.scss"],
  providers: [
    PublicPURLPageService,
    LandingPageTrackingService,
    {
      provide: AbstractPublicLandingPageService,
      useExisting: PublicPURLPageService
    }
  ]
})
export class PURLPageComponent extends LandingPageComponent {}
